const POLL_MS = 100

/**
 * The element matching `selector`, or null if it is absent or has no box.
 *
 * An empty wrapper (the '?' slot on a page with no explainer, a card that
 * rendered nothing) still matches the selector, but highlighting a 0x0 box
 * points the reader at nothing, so it counts as missing.
 */
export function findVisible(selector) {
    const el = document.querySelector(selector)
    if (!el) return null
    const rect = el.getBoundingClientRect()
    return rect.width > 0 || rect.height > 0 ? el : null
}

/**
 * Poll for a visible `selector` for up to `timeoutMs`. Resolves the element,
 * or null on timeout or once `isCancelled()` turns true.
 */
export function waitForElement(selector, timeoutMs, isCancelled = () => false) {
    const deadline = Date.now() + timeoutMs
    return new Promise((resolve) => {
        const check = () => {
            if (isCancelled()) return resolve(null)
            const el = findVisible(selector)
            if (el) return resolve(el)
            if (Date.now() >= deadline) return resolve(null)
            setTimeout(check, POLL_MS)
        }
        check()
    })
}
